import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxIconStackModule } from '@wdx/shared/components/wdx-icon-stack';
import {
    FunctionPipe,
    SeverityPipe,
    TranslateTokenisedStringPipe,
} from '@wdx/shared/utils';
import { AtomAvatarModule } from '../../../components/atoms/atom-avatar/atom-avatar.module';
import { AtomSeverityIndicatorsModule } from '../../../components/atoms/atom-severity-indicators/atom-severity-indicators.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { MoleculeContextMenuComponent } from './molecule-context-menu.component';

@NgModule({
    imports: [
        AtomAvatarModule,
        AtomSeverityIndicatorsModule,
        CommonModule,
        DirectivesModule,
        NgbDropdownModule,
        PipesModule,
        RouterModule,
        WdxIconModule,
        WdxIconStackModule,
        SeverityPipe,
        FunctionPipe,
        TranslateTokenisedStringPipe,
    ],
    declarations: [MoleculeContextMenuComponent],
    exports: [MoleculeContextMenuComponent],
})
export class MoleculeContextMenuModule {}
